var map = {
	"./account.js": "a9f0",
	"./account_new.js": "438b",
	"./bi.js": "3d2f",
	"./branch_new.js": "b751",
	"./center.js": "fc65",
	"./certificate.js": "90f3",
	"./classification.js": "810f",
	"./company.js": "4bcb",
	"./configuration.js": "948c",
	"./course.js": "f8c5",
	"./courseCenter.js": "1f99",
	"./exam.js": "8cf9",
	"./face.js": "244b",
	"./home.js": "1a2c",
	"./kc.js": "80eb",
	"./locale.js": "67e7",
	"./manage.js": "8f1b",
	"./market.js": "df35",
	"./operate.js": "d998",
	"./organize.js": "78c2",
	"./paperment.js": "33f3",
	"./permission_new.js": "9c34",
	"./region.js": "1649",
	"./resource.js": "ceb4",
	"./role.js": "73a2",
	"./saas_new.js": "14f8",
	"./shanglianhui.js": "de6e",
	"./student.js": "a4ac",
	"./testment.js": "ee64",
	"./training.js": "73eb",
	"./userIdentityX_new.js": "3e87",
	"./user_new.js": "09f7",
	"./usercenter.js": "d6e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";